export const AFFIRM_TERM_MONTHS_DOOR_TO_DOOR = 12
export const DOOR_TO_DOOR_APR = 0.068
